<div class="h-full w-full flex flex-col justify-center items-center">
  <app-appointment-weekly-calender></app-appointment-weekly-calender>
</div>
